package br.com.vvrefeicoes.portal.core.ui.theme

import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.shadow
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.Shape
import androidx.compose.ui.unit.dp

/** Sombra padrão de cards: deslocamento 1, desfoque 3, #000000 a 10%. */
val CardShadowColor = Color(0x1A000000)

fun Modifier.cardElevation(shape: Shape = AppShapes.large): Modifier =
    shadow(
        elevation = 3.dp,
        shape = shape,
        clip = false,
        ambientColor = CardShadowColor,
        spotColor = CardShadowColor,
    )
